import { createFileRoute } from "@tanstack/react-router";
import DashboardRedirect from "@/app/dashboard/[id]/page";

export const Route = createFileRoute("/clients/$clientId/dashboard/")({
  component: DashboardRedirect,
});
